var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPollH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4763_2349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0H4.5C2.02 0 0 2.02 0 4.5V19.5C0 21.98 2.02 24 4.5 24H19.5C21.98 24 24 21.98 24 19.5V4.5C24 2.02 21.98 0 19.5 0ZM23 19.5C23 21.43 21.43 23 19.5 23H4.5C2.57 23 1 21.43 1 19.5V4.5C1 2.57 2.57 1 4.5 1H19.5C21.43 1 23 2.57 23 4.5V19.5ZM5 9.5C5 9.22 5.22 9 5.5 9H15.5C15.78 9 16 9.22 16 9.5C16 9.78 15.78 10 15.5 10H5.5C5.22 10 5 9.78 5 9.5ZM5 5.5C5 5.22 5.22 5 5.5 5H12.5C12.78 5 13 5.22 13 5.5C13 5.78 12.78 6 12.5 6H5.5C5.22 6 5 5.78 5 5.5ZM19 13.5C19 13.78 18.78 14 18.5 14H5.5C5.22 14 5 13.78 5 13.5C5 13.22 5.22 13 5.5 13H18.5C18.78 13 19 13.22 19 13.5ZM9 17.5C9 17.78 8.78 18 8.5 18H5.5C5.22 18 5 17.78 5 17.5C5 17.22 5.22 17 5.5 17H8.5C8.78 17 9 17.22 9 17.5Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4763_2349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollH);
export default __webpack_public_path__ + "static/media/poll-h.da218ba97ea4a84c7aec2c18a520e0f9.svg";
export { ForwardRef as ReactComponent };